import React, { useEffect, useRef, useState } from 'react';
import { $ } from "react-jquery-plugin";
import { savePDF } from '@progress/kendo-react-pdf';
import { Grid, Text } from '@nextui-org/react';
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { fileUpload } from '../../../apis/urls';
import { userStore } from '../../../store/userStore';
import { message, notification } from 'antd';


const OfficialPaymentPDF =()=> {

    const pdfRef = useRef(null);

    const {sname, assname, count} = useParams();

    const storeData = userStore()

    const [api, contextHolder] = notification.useNotification();

    const openNotification = () => {
      api.open({
        message: 'Information',
        duration: 200,
        description:
          `A pdf version of this form would have got downloaded. Please take a print of the same and send it to GISA along with the check.
          You can download the same form again from the officials listing page if required by clicking " Previous payment forms"`,
        className: 'custom-class',
        style: {
          width: 600,
        },
      });
    };

    useEffect(() => {

        $('body').removeClass('').addClass('sidebar-collapsed');

        openNotification()

        const content = pdfRef.current;

        const doc = new jsPDF('p', 'mm', 'a4');
        doc.html(content, {
            callback: function (doc) {
                doc.save('payment_form.pdf');
                const blob = doc.output('blob');
                const file = new File([blob], 'payment_form.pdf', { type: 'application/pdf' });
                handleSavePDF(file);
            },
            html2canvas: { scale: 0.353 } 
        });
    },[]);

    const handleSavePDF = (file) => {

        const data = new FormData();
        data.append('file', file)
        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${fileUpload}/upload`,
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data)

        .then((response) => {
            handleSavePDFFile(response?.data?.Location)
        })

        .catch((error) => {
            console.log(error);
        });

    }

    const handleSavePDFFile = (file) => {

        const data = {
            asso_id: storeData.official.id,
            amount: storeData.official.amount,
            count: storeData.official.count,
            file: file
        }

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${fileUpload}/store`,
            timeout: 1000000,
            headers: {'authorization': token},
        });


        instance.post('', data)

        .then((response) => {
            // console.log(response);
        })

        .catch((error) => {
            console.log(error);
        });

    }

    const currentFinancialYear = () => {
        let date = new Date();
        let month = date.getMonth();
        let year = date.getFullYear();
        if(month > 3){
            return year+'-'+(year+1)
        }else{
            return (year-1)+'-'+year
        }
    }


    return (
    <div className="wrapper">
        <aside className="right-side">
            <div>
            {contextHolder}                    
            </div>
            <div style={{ background:'#f0f0f0', padding:0}} className="content-area no-header pdf-association">
                <div style={{height:'0px', marginBottom:'83px', display:'flex', alignItems:'center'}} className='association-pdf'>
                    <button style={{marginTop:'84px', marginLeft:'0px', backgroundColor:'transparent', marginBottom:'0px'}} className='back-button' onClick={() => window.history.back()}><i className='icon-chevron-left'></i>Back to officials</button>
                </div>
                <div className='association-pdf' ref={pdfRef}>       
                    <div>
                        <img src={require('../../../images/giaa.png')} className="form-image" alt=''/>
                        <p style={{fontSize:'14px', fontWeight:900, textTransform:'uppercase', marginBottom:'-5px', marginTop:'10px'}}>{assname}</p>
                        <p style={{fontSize:'12px', fontWeight:600, textTransform:'uppercase', marginBottom:'-8px'}}>OFFICIALS&nbsp;&nbsp;&nbsp;REGISTRATION </p>
                        <p style={{fontSize:'12px', fontWeight:600, textTransform:'uppercase',}}>REQUEST&nbsp;&nbsp;FOR&nbsp;&nbsp;APPROVAL&nbsp;&nbsp;TO&nbsp;&nbsp;OFFICIATE&nbsp;&nbsp;GIAA&nbsp;&nbsp;EVENTS </p>
                    </div>
                    <div>
                        <p style={{fontSize:'10px', marginTop:'-8px'}}>Please print this page and send this completed form along with the appropriate registration fees to: </p>
                        <p style={{fontSize:'10px',fontWeight:900, marginTop:'-8px'}} >GISA, Post Office Box 9, Dawsonville, GA 30534</p>
                    </div>
                    <div style={{marginTop:'-30px'}}>
                        <Grid.Container gap={2} justify="center" className='sport-from'>
                            <Grid xs={1} style={{justifyContent:'flex-start'}}>
                                <p style={{fontSize:'13px'}}>From</p>
                            </Grid>
                            <Grid xs={1} style={{justifyContent:'center'}}>
                                :
                            </Grid>
                            <Grid xs={10} style={{justifyContent:'flex-start'}}>
                                <p style={{fontSize:'13px', fontWeight:'800'}}>{assname}</p>
                            </Grid>
                        </Grid.Container>
                        <Grid.Container gap={2} justify="center" className='sport-from sports-top'>
                            <Grid xs={1} style={{justifyContent:'flex-start'}}>
                                <p style={{fontSize:'13px'}}>Sports</p>
                            </Grid>
                            <Grid xs={1} style={{justifyContent:'center'}}>
                                :
                            </Grid>
                            <Grid xs={10} style={{justifyContent:'flex-start'}}>
                                <p style={{fontSize:'13px', fontWeight:'800'}}>{sname}</p>
                            </Grid>
                        </Grid.Container>

                        <Grid.Container gap={2} justify="center" className='sport-from sports-top' style={{width:'90%'}}>
                            <Grid xs={12} style={{justifyContent:'center'}}>
                            <ol type="none" style={{listStyle:'none'}}>
                                <li style={{paddingTop:'0px'}}>
                                    <div style={{fontSize:'12px'}}>A. Enclosed (or attached) are the following:</div>
                                </li>
                                    <div style={{fontSize:'10px', paddingLeft:'20px', marginTop:'5px'}}>1. This Association Contact Registration Form </div><br />
                                    <div style={{fontSize:'10px', paddingLeft:'20px', marginTop:'-15px'}}>2. Our CHECK to cover the cost of registration for the {currentFinancialYear()} school year at $15.00 per official. </div>
                                <li style={{paddingTop:'10px'}}>
                                    <span style={{fontSize:'12px'}}>B. As the appropriate officer in this association, I do hereby certify the following:</span>
                                </li>
                                    <div style={{fontSize:'10px', paddingLeft:'20px', marginTop:'5px'}}>1. Each official on the attached list has successfully completed a written rules examination for the applicable NFHS rules to apply for the {currentFinancialYear()} school year. </div><br />
                                    <div style={{fontSize:'10px', paddingLeft:'20px', marginTop:'-15px'}}>2. As appropriate, each official listed has successfully completed "on the court" or "field training". </div><br />
                                    <div style={{fontSize:'10px', paddingLeft:'20px', marginTop:'-15px'}}>3. Each official has been given a photocopy or a summary of the appropriate GIAA Rules pertaining to this sport and is aware of the "few" differences or requirements set for by GIAA. </div><br />
                                <li style={{paddingTop:'10px'}}>
                                    <div style={{fontSize:'12px', marginTop:'-15px'}}>C. Enclosed is our check for the following number of officials:</div>
                                </li>
                            </ol>
                            </Grid>
                        </Grid.Container>
                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={12} style={{justifyContent:'center', marginTop:'-15px'}}>
                                <span style={{fontWeight:'900'}}>{count} Officials x $15.00 = ${count * 15}.00</span>
                            </Grid>
                            <Grid xs={12} style={{justifyContent:'center', marginTop:'-15px'}}>
                                <span style={{fontSize:'12px'}}>NOTE: Make check payable to GISA, and mail to PO Box 9, Dawsonville, GA 30534</span>
                            </Grid>
                            <Grid xs={12} style={{justifyContent:'center'}}>
                                <span style={{fontSize:'10px', marginTop:'-20px'}}>
                                    I understand that by filing this request and compliance with same when approved by the GISA Office, will result in this Association being duly registered and included on the "Approved List of Officials"  
                                </span>
                            </Grid>

                            <Grid xs={12} style={{justifyContent:'center', marginTop:'-10px'}}>
                                <span style={{fontSize:'10px', color:'red', fontWeight:800, marginTop:'-10px'}}>
                                    ( Note: Schools using any officials not approved by this office will result in subjecting the school to severe monetary and other disciplinary penalties. )
                                </span>
                            </Grid>


                            <Grid xs={12} style={{justifyContent:'flex-start', marginTop:'-20px'}}>
                                <span style={{fontSize:'12px'}}>
                                    Print Name of Appropriate Official 
                                </span>
                            </Grid>

                            <Grid xs={12} style={{justifyContent:'flex-start'}}>
                                <span style={{fontSize:'12px', marginTop:'30px'}}>
                                    Signature of Appropriate Official 
                                </span>
                            </Grid>

                            <Grid xs={12} style={{justifyContent:'flex-start'}}>
                                <span style={{fontSize:'12px', marginTop:'40px'}}>
                                    Date :
                                </span>
                            </Grid>
                        </Grid.Container>
                    </div>
                </div>
            </div>
        </aside>
    </div>
    )
}

export default OfficialPaymentPDF 